package pt.at.oss.kotlin.manual.enumeration
/**
 * Created by Pedro Alfaiate on 11/05/2020.
 */
enum class CustomErrorCodes {
    VAT_ID_ONE_TYPE_REQUIRED,
    VAT_ID_ONLY_ONE_ALLOWED,
    VAT_ID_PARTIALLY_FILLED,

    VAT_ID_VAT_TYPE_NOT_ALLOWED,
    VAT_ID_TAX_TYPE_NOT_ALLOWED,
    VAT_ID_SCHEME_NOT_ALLOWED,
    VAT_ID_INVALID_VAT_FORMAT,
    VAT_ID_INVALID_VOES_FORMAT,
    VAT_ID_INVALID_IOSS_FORMAT,
    VAT_ID_INVALID_INT_FORMAT,
    VAT_ID_TAX_REF_NUM_INVALID_FORMAT,

    HAVE_TRADING_NAMES_BUT_NO_COMPANY_NAME,

    WEBSITE_INVALID,
    WEBSITE_NOT_GIVEN,

    COUNTRY_OF_BUSINESS_INVALID,
    BUSINESS_AND_ISSUING_COUNTRIES_NOT_EQUAL,
    COB_REGION_SHOULD_BE_USED,
    ISSUER_COUNTRY_NOT_EQUAL_PARENT,
    ISSUING_COUNTRY_MS_IS_EU_COUNTRY,
    ISSUING_COUNTRY_NOT_EQUAL_REGION,
    ISSUER_COUNTRY_XIXU_NOT_ALLOWED,
    ISSUER_CODE_NOT_COUNTRY,
    COUNTRY_OF_BUSINESS_EU_NO_REGION,
    COUNTRY_OF_BUSINESS_GB_NO_REGION,
    REGION_WRONG_COUNTRY_OF_BUSINESS,
    REGION_NOT_OUTSIDE_UNION,

    ADDRESS_COUNTRY_INVALID,
    ADDRESS_REGION_WRONG_COUNTRY,
    ADDRESS_UK_NO_REGION,
    ADDRESS_STRUCTURED_FIELDS_BUT_NOT_STRUCTURED,
    ADDRESS_POST_CODE_INVALID_FORMAT,
    ADDRESS_WITH_ARTIFICIAL_CODE_NOT_ALLOWED,

    CONTACT_NAME_STRUCTURED_FIELDS_BUT_NOT_STRUCTURED,

    EMAIL_INVALID,
    EMAIL_CONFIRMATION_NOT_EQUAL,
    TELEPHONE_INVALID,

    BANK_ACCOUNT_INFO_NOT_ALLOWED,
    BANK_ACCOUNT_ID_NOT_PROVIDED,
    IBAN_OBAN_BOTH_NOT_ALLOWED,
    IBAN_INVALID,
    BIC_INVALID,
    ACCOUNT_HOLDER_INVALID,
    OBAN_NOT_ALLOWED,
    ONLY_SINGLE_SPACES_ALLOWED,

    COMMENCEMENT_DATE_NOT_ALLOWED,
    COMMENCEMENT_DATE_BEFORE_OSS_START,

    FIXED_ESTABLISHMENT_DUPLICATED,
    FIXED_ESTABLISHMENT_NOT_REAL,
    FIXED_ESTABLISHMENT_NOT_STOCK,

    FREE_TEXT_INVALID_CHARACTER,
    ;

    val code = name
}
